<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <view-table
            ref="viewTable"
            :filter="filter"
            :limits="limits"
            :columns-property="columnsProperty"
            module="basic"
            url="qmTemplates/product"
            @addOrEdit="addEditHandle"
            @select="selectHandle"
            @delete="deleteHandle"
            @reset="resetHandle">
          <template slot="adSearch">
            <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
              <el-form-item label="编号">
                <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="物料编号">
                <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="物料名称">
                <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="规格型号">
                <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="工序">
                <el-input v-model.trim="filter.processName" placeholder="请输入" clearable/>
              </el-form-item>
            </el-form>
          </template>
        </view-table>
        <!-- 编辑 -->
        <material-template-edit ref="templateEdit" @save-success="loadData"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import MaterialTemplateEdit from "./ProductTemplateEdit1";

  export default {
    name: "ProductTemplateList1",
    components: {
      ViewTable,
      MaterialTemplateEdit,
    },
    data() {
      return {
        limits: {
          // addAuth: this.$auth(517),
          editAuth: this.$auth(628),
          delAuth: this.$auth(629),
        },
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        filterText: "",
        filter: {
          no: "",
          materialNo: "",
          materialName: "",
          specification: "",
          processName: "",
        },
        columnsProperty: [
          {
            key: "no",
            align: "center",
          },
          {
            key: "name",
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },

    methods: {
      addEditHandle(row) {
        this.$refs.templateEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        // this.$confirm("确定删除吗?", "提示", {type: "warning"})
        //     .then(() => {
        this.$http.delete("basic", "qmTemplates", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
        // })
        // .catch(() => {
        // });
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
        console.log(this.selection);
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
